const ArrowDownLoad = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M15.2444 16.4982C15.6586 16.4982 15.9944 16.834 15.9944 17.2482C15.9944 17.6279 15.7123 17.9417 15.3462 17.9914L15.2444 17.9982H4.74976C4.33554 17.9982 3.99976 17.6624 3.99976 17.2482C3.99976 16.8685 4.28191 16.5547 4.64799 16.505L4.74976 16.4982H15.2444ZM10.0034 2C10.3831 2 10.6969 2.28215 10.7465 2.64823L10.7534 2.75L10.7528 12.943L13.719 9.97242C13.985 9.70591 14.4016 9.68132 14.6955 9.8989L14.7796 9.97144C15.0461 10.2375 15.0707 10.6541 14.8532 10.9479L14.7806 11.0321L10.5378 15.2827L10.4671 15.3453L10.3762 15.4039L10.3397 15.425L10.2486 15.4629L10.1281 15.493L10.0588 15.501L9.99876 15.5029C9.94864 15.5029 9.89776 15.4974 9.84804 15.4868L9.76716 15.4637C9.67115 15.4327 9.58404 15.3824 9.50989 15.3177L5.22032 11.033C4.92721 10.7403 4.92688 10.2654 5.21956 9.97231C5.48564 9.70585 5.90228 9.68135 6.19605 9.89899L6.28022 9.97155L9.25276 12.939L9.25338 2.75C9.25338 2.33579 9.58917 2 10.0034 2Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowDownLoad;
